module.exports = __webpack_public_path__ + "static/flags/PC-8efc4305690f296616a1a3216c545b06.gif";